var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1540_908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1661 2.27206L24.3617 8.96344C24.805 10.3184 26.0928 11.2356 27.5284 11.2356H34.6428C37.8728 11.2356 39.2028 15.3213 36.6061 17.1974L30.8428 21.3248C29.6817 22.1586 29.1961 23.6386 29.6395 24.9935L31.835 31.6849C32.8272 34.7075 29.3228 37.2298 26.705 35.3537L20.9417 31.2263C19.7806 30.3925 18.1972 30.3925 17.015 31.2263L11.2517 35.3537C8.63391 37.2298 5.12947 34.7075 6.12169 31.6849L8.31725 24.9935C8.76058 23.6386 8.27503 22.1586 7.11391 21.3248L1.35058 17.1974C-1.2672 15.3213 0.0839155 11.2356 3.31392 11.2356H10.4284C11.8639 11.2356 13.1517 10.3184 13.595 8.96344L15.7906 2.27206C16.7828 -0.750519 21.1317 -0.750519 22.1239 2.27206H22.1661Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1540_908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ba8309f14b35cfcd4686fb29361d1423.svg";
export { ForwardRef as ReactComponent };